import {createSelector} from 'reselect';
import {getPaymentOptions} from '../../../selectors/PaymentOptionSelectors/PaymentOptionSelectors';

export default createSelector(
  [getPaymentOptions],
  paymentOptions => paymentOptions.some(option => option.type === 'APPLEPAY'),
);
